import React, { Component } from 'react'
import { NavLink, withRouter } from 'react-router-dom'

import IntlMessages from 'util/IntlMessages'
import CustomScrollbars from 'util/CustomScrollbars'

class SidenavContent extends Component {
  componentDidMount () {
    const {history} = this.props
    const that = this
    const pathname = `#${history.location.pathname}`// get current path

    const subMenuLi = document.querySelectorAll('.sub-menu > li')
    for (let i = 0; i < subMenuLi.length; i++) {
      subMenuLi[i].onclick = function (event) {
        event.stopPropagation()
      }
    }

    const menuLi = document.getElementsByClassName('menu')
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li')
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open')
          }
        }
        this.classList.toggle('open')
        event.stopPropagation()
      }
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]')// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul') // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open')
      } else {
        this.closest(activeLi, 'li').classList.add('open')
      }
    } catch (error) {

    }
  }

  closest (el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] == 'function') {
          matchesFn = fn
          return true
        }
        return false
      })

      let parent

      // traverse parents
      while (el) {
        parent = el.parentElement
        if (parent && parent[matchesFn](selector)) {
          return parent
        }
        el = parent
      }
    } catch (error) {

    }

    return null
  }

  render () {
    return (
      <CustomScrollbars className="scrollbar">
        <ul className="nav-menu">

          <li className="nav-header"><IntlMessages id="sidebar.main"/></li>

          <li className="menu collapse-box">
            <NavLink className="prepend-icon" to="/script-log">
              <span className="nav-text">Script Log</span>
            </NavLink>
            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/script-log/setup">
                  <span className="nav-text">Setup</span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/script-log/write">
                  <span className="nav-text">Write</span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/script-log/view">
                  <span className="nav-text">View</span>
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </CustomScrollbars>
    )
  }
}

export default withRouter(SidenavContent)



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js